import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import ThemedPrice, * as ThemedPriceDef from '../../ThemedPrice';

import styles from './Price.module.scss';

const Price = ({
  color = 'default',
  biggerFont = false,
  biggerFontMonthly = false,
  inline = false,
  className = '',
  ...props
}) => {
  const i18n = {
    from: trans('rentable_unit_price.label.from'),
    perMonth: trans('price_tag.label.per_month')
  };

  const theme = {
    currency: styles.currency,
    price: classNames(styles.price, {
      [styles['price--bigger-font']]: biggerFont
    }),
    priceMonthly: classNames(
      styles['price-monthly'],
      styles['price-monthly--rebranding-style'],
      {
        [styles['price-monthly--bigger-font']]: biggerFontMonthly
      }
    ),
    wrapper: classNames(
      styles.wrapper,
      styles[`wrapper--${color}`],
      {
        [styles['wrapper--inline']]: inline
      },
      className
    )
  };

  return <ThemedPrice {...props} i18n={i18n} theme={theme} />;
};

Price.propTypes = {
  ...ThemedPriceDef.propTypes,
  className: PropTypes.string,
  biggerFont: PropTypes.bool,
  biggerFontMonthly: PropTypes.bool,
  inline: PropTypes.bool,
  color: PropTypes.oneOf(['default', 'light-black', 'interaction', 'dark'])
};

export default Price;
